import axios from '../apiEditor';
import qs from 'qs';

export default {
	getLanguages() {
		return axios.get().get(`/editor/languages`);
	}
};
